export const Routes = {
  // home: "/",
  // login: "/login",
  messageCatalog: "/messageCatalog",

};
